// สรุปเปอร์เซ็นต์ของขึ้น ของเสีย — kept free of imports so the sidebar and the router can read the
// path without pulling the page's helpers in.

export const WASTE_PERCENT_REPORT_PATH = "/report/waste-percent";

export const WASTE_PERCENT_REPORT_TITLE = "สรุปเปอร์เซ็นต์ของขึ้น ของเสีย";

/** The API's `month` parameter and the report's own `month` field. */
export const API_MONTH_FORMAT = "YYYY-MM";

/** The API serves 2000-01 onwards; an earlier month would only be refused. */
export const EARLIEST_REPORT_MONTH = "2000-01-01";

export const UNCATEGORIZED_LABEL = "ไม่ระบุหมวด";

export const TOTAL_ALL_LABEL = "รวมขนมทุกชนิด";

export const TOTAL_EXCLUDING_DRY_GOODS_LABEL = "รวมขนม (หักขนมแห้ง)";

export const TOTAL_EXCLUDING_DRY_GOODS_CAPTION = "ใช้คิดเปอร์เซ็นต์เสียเพื่อจ่ายค่าคอมมิชชั่น";
